import React, { useMemo } from "react";
import MaleFaceFrontImage from "@shared/assets/face/male/face-front.svg?react";
import MaleFaceBackImage from "@shared/assets/face/male/face-back.svg?react";
import MaleFaceLeftImage from "@shared/assets/face/male/face-left.svg?react";
import MaleFaceRightImage from "@shared/assets/face/male/face-right.svg?react";
import FemaleFaceFrontImage from "@shared/assets/face/female/face-front.svg?react";
import FemaleFaceBackImage from "@shared/assets/face/female/face-back.svg?react";
import FemaleFaceLeftImage from "@shared/assets/face/female/face-left.svg?react";
import FemaleFaceRightImage from "@shared/assets/face/female/face-right.svg?react";
import { Control, Controller, FieldValues } from "react-hook-form";
import { ComplaintsOverview } from "../complaints/overview";

const getPerspectives = (gender?: string) => {
  if (gender === "female") {
    return {
      front: {
        SvgComponent: FemaleFaceFrontImage,
        width: 148,
        height: 245,
      },
      back: {
        SvgComponent: FemaleFaceBackImage,
        width: 151,
        height: 245,
      },
      left: {
        SvgComponent: FemaleFaceLeftImage,
        width: 242,
        height: 245,
      },
      right: {
        SvgComponent: FemaleFaceRightImage,
        width: 242,
        height: 245,
      },
    };
  }

  return {
    front: {
      SvgComponent: MaleFaceFrontImage,
      width: 158,
      height: 245,
    },
    back: {
      SvgComponent: MaleFaceBackImage,
      width: 162,
      height: 245,
    },
    left: {
      SvgComponent: MaleFaceLeftImage,
      width: 176,
      height: 245,
    },
    right: {
      SvgComponent: MaleFaceRightImage,
      width: 176,
      height: 245,
    },
  };
};

type ControlledFaceComplaintsMapProps = {
  gender?: string;
  name: string;
  control: Control<FieldValues>;
};

export const ControlledFaceComplaintsMap: React.FC<
  ControlledFaceComplaintsMapProps
> = ({ gender, control, name }) => {
  const perspectives = useMemo(() => getPerspectives(gender), [gender]);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <ComplaintsOverview
          value={field.value}
          onChange={field.onChange}
          {...perspectives}
        />
      )}
    />
  );
};
